<template lang="html">
  <main class="buy container-fluid px-0">
    <StatusBar :breadcrumbs="[...categoryBreadcrumbs]" noFilters />
    <div class="row">
      <div class="col-12 mx-auto d-none d-sm-block mt-4 mb-0" style="max-width: 1140px;">
        <h3 class="text-primary">Comprar</h3>
      </div>

      <div class="buy-form col-12 col-sm-12 ">
        <ul class="nav nav-tabs d-none d-sm-flex">
          <li :class="`nav-item nav-link ${step === 'quantity' ? 'active' : ''}`" @click="goToQuantity">
            Producto
          </li>
          <li v-if="shippingType == 'INCLUDED_IN_PRICE'"
            :class="`nav-item nav-link ${step === 'delivery' ? 'active' : ''}`"
            @click="goToDelivery"
          >
            Datos de envío
          </li>
          <li :class="`nav-item nav-link ${step === 'confirmation' ? 'active' : ''}`" @click="goToConfirmation">
            Confirmación
          </li>
        </ul>
        <div class="buy-form-content p-4">
          <div class="tab-content" id="buy-content">
            <div v-show="step === 'quantity'" :class="`tab-pane ${ step === 'quantity' ? 'active' : ''}`">
              <TabQuantity
                :shippingType="shippingType"
                @goToDelivery="goToDelivery"
                @goToConfirmation="goToConfirmation"
              />
            </div>
            <div v-show="step === 'delivery'" :class="`tab-pane ${ step === 'delivery' ? 'active' : ''}`"
              v-if="shippingType == 'INCLUDED_IN_PRICE'"
            >
              <TabDelivery
                @goToQuantity="goToQuantity"
                @goToConfirmation="goToConfirmation"
              />
            </div>
            <div v-show="step === 'confirmation'" :class="`tab-pane ${ step === 'confirmation' ? 'active' : ''}`">
              <TabConfirmation
                @goToDelivery="goToDelivery"
                @goToQuantity="goToQuantity"
                :shippingType="shippingType"/>
            </div>
          </div>
        </div>
      </div>

    </div>

    <Loading :active="isFetching" />

  </main>
</template>

<script>
import store from '@/store'
import StatusBar from '@/components/layout/StatusBarBase'
import TabQuantity from './tabs/TabQuantity'
import TabConfirmation from './tabs/TabConfirmation'
import TabDelivery from './tabs/TabDelivery'

export default {
  components: {
    StatusBar,
    TabQuantity,
    TabConfirmation,
    TabDelivery,
  },

  data: () => ({
    show: null,
    step: 'quantity',
    stepQuantity: 'quantity',
    stepDelivery: 'delivery',
    stepConfirmation: 'confirmation',
    hasChanges: false,
    updateInterval: null
  }),

  mounted () {
    if (!this.details.ready) {
      this.fetch()
    }

    if (this.$route.name == 'buy') {
      this.step = this.$route.params.step ? this.$route.params.step : 'quantity'
    }

    if (this.$route.name == 'buy' && this.$route.params.step != 'quantity') {
      const orderId = this.$route.params.order;
      if (orderId) {
        store.dispatch("buy/getOrder", orderId)
      }
    }

    this.updateInterval = setInterval(this.compareAndSend, 5000)
  },

  watch: {
    quantity (newValue, oldValue) {
      if(newValue != oldValue)
        this.hasChanges = true
    },
    shipment (newValue, oldValue) {
      if(newValue != oldValue)
        this.hasChanges = true
    },
  },

  computed: {

    isFetching: () => store.state.isFetching,

    details: () => store.getters['publication/preview'],

    shippingType: () => {
      if(store.state.publication.product[0]) {
        return store.state.publication.product[0].shipping_type
      }else{
        return ''
      }
    },

    categoryBreadcrumbs: () => store.state.publication.categoryPath,

    quantity: () => store.state.buy.quantity,

    delivery: () => store.state.buy.delivery,

    order: () => store.state.buy.order,

    shipment: () => Object.values(store.state.buy.delivery).join(",")

  },

  methods: {

    fetch () {
      store.dispatch('setIsFetching', true)
      return store.dispatch('publication/getSheet', this.$route.params.id)
        .finally(() => { store.dispatch('setIsFetching', false) })
    },

    goToConfirmation () {
      this.$router.push({ name: 'buy', params: { id: this.details.id, step: this.stepConfirmation, order: this.order.id } })
      this.step = 'confirmation'
    },

    goToQuantity () {
      this.$router.push({ name: 'buy', params: { id: this.details.id, step: this.stepQuantity } })
      this.step = 'quantity'
    },

    goToDelivery () {
      this.$router.push({ name: 'buy', params: { id: this.details.id, step: this.stepDelivery, order: this.order.id } })
      this.step = 'delivery'
    },

    compareAndSend () {
      if(this.hasChanges === true) {
        this.hasChanges = false
      }
    },

  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';
  @import '../../scss/aspect';
  @import '../../scss/breakpoints';

  .required-tip {
    color: red;
  }

  .buy {
    padding-top: $navbar-height;
    background-color: $gray-200;

    & .nav-tabs {
      & .nav-item {
        & .nav-link {
          color: $gray-800;

          &.active {
            font-weight: bold;
          }
        }
      }
    }

    &-form {
      max-width: $max-width;
      margin: 2rem auto;

      &-content {
        background-color: $white;
        min-height: 90vh;
      }
    }

    &-buttons {
      margin-top: 3rem;
      text-align: center;
    }
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    .buy {
      &-form {
        margin-top: 0;
        margin-bottom: 33%;

        label {
          color: initial;
        }
      }

      &-buttons {
        margin-top: 1.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/marketplace/BuyPage.vue